import { Container, CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "react-query";
import { Modal } from "../components/Modal";
import { auth } from "../firebase";
import ResetPassword from "./ResetPassword";
import VerifyEmail from "./VerifyEmail";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import theme from "../theme";
import { ThemeProvider } from "@mui/system";

const queryClient = new QueryClient();

const EmailActionHandler = () => {
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  if (!pageLoaded || typeof window === "undefined") return null;

  const urlSearchParams = new URLSearchParams(window.location.search);
  const {
    mode,
    oobCode,
    continueUrl = "/",
    lang = "en",
  } = Object.fromEntries(urlSearchParams.entries());

  if (!mode) return null;

  const Component = {
    resetPassword: ResetPassword,
    verifyEmail: VerifyEmail,
  }[mode];

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Modal isOpen={!!mode}>
          <Container component="main" maxWidth="xs">
            <CssBaseline />
            <Component
              auth={auth}
              continueUrl={continueUrl}
              oobCode={oobCode}
              lang={lang}
            />
          </Container>
        </Modal>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default EmailActionHandler;

EmailActionHandler.propTypes = {};
